export default __webpack_public_path__ + "static/media/logo-google.669d71c0.png";